/* WIM · CRO · «Completa tu look» en el carrito lateral y en la página de carrito.
   El tema vuelve a pintar el carrito al cambiar cantidades: se observa el DOM y se rellena desde caché. */
(function () {
  var cache = {};
  function fill(box) {
    var id = box.getAttribute('data-product-id');
    if (!id || box.getAttribute('data-filled') === id) return;
    box.setAttribute('data-filled', id);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var p = cache[id] || (cache[id] = fetch(root + 'recommendations/products?section_id=wim-cart-recos&limit=10&product_id=' + id)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('.wim-cart-recos__inner');
        return inner ? inner.outerHTML : '';
      }).catch(function () { return ''; }));
    p.then(function (html) {
      if (box.getAttribute('data-product-id') !== id) return;
      box.innerHTML = html;
      box.hidden = !html || !box.querySelector('.wim-cart-recos__item');
    });
  }
  function scan() { document.querySelectorAll('[data-wim-cart-recos]').forEach(fill); }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
